export enum SidebarDisplayTypes {
    SIDEBAR_DISPLAY_BLOCK = 'block',
    SIDEBAR_DISPLAY_NONE = 'none',
}
